import type { VisualInspectionDataDto } from '@/api/generated/HCA'
import type { ComposerTranslation } from 'vue-i18n'

export const generatorViReportColumnField = (report: VisualInspectionDataDto, index: number) =>
    `__vi_${report.id ?? 'new'}_${index}`

/** Header / link label; avoids showing component SID when it was stored as analyticalNumber. */
export const getGeneratorViReportHeaderLabel = (
    report: VisualInspectionDataDto,
    index: number,
    generatorSidTrimmed: string,
    t: ComposerTranslation,
): string => {
    const raw = report.analyticalNumber?.trim() ?? ''
    const gid = generatorSidTrimmed
    if (raw && gid && raw === gid) {
        return t('generators.conditionStatus.content.visualInspections.reportFallback', { id: report.id ?? index + 1 })
    }
    if (raw) {
        return raw
    }
    return t('generators.conditionStatus.content.visualInspections.reportFallback', { id: report.id ?? index + 1 })
}
